function isLocalHost(): boolean {
    const hostName = window?.location?.hostname ?? '';

    if (hostName === 'localhost') {
        return true;
    }

    if (hostName === '[::1]') {
        return true;
    }

    if (hostName.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) {
        return true;
    }

    return false;
}

const module = {
    isLocalHost,
};

export default module;
